const commendatory_letters = {
  permissionSource: 'api::commendatory-letter.commendatory-letter',
  creationTitle: 'Create Commendatory Letter',
  creationEndPoint: '/commendatory-letters',
  detailTitle: 'Commendatory Letter: :code',
  detailEndPoint:
    '/commendatory-letters/:id?populate[0]=staff.personal_info&populate[1]=issued_by.personal_info',
  detail: [
    {
      label: 'Code',
      value: 'code',
      tag: 'input',
      type: 'text',
      placeholder: 'Commendatory Letter Code',
      required: true,
    },
    {
      label: 'Date',
      value: 'date',
      tag: 'date-picker',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1',
      children: [
        {
          label: 'Staff',
          value: 'staff',
          tag: 'single-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
          required: true,
        },
        {
          label: 'Issued by',
          value: 'issued_by',
          tag: 'single-select',
          dataSourceUrl: '/staffs',
          dataLabel: 'name',
          required: true,
        },
      ],
    },
    {
      label: 'Subject',
      value: 'subject',
      tag: 'input',
      type: 'text',
    },
    {
      label: 'Content',
      value: 'content',
      tag: 'richTextarea',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default commendatory_letters
